import { Button, HStack, Icon, Text } from '@chakra-ui/react'
import * as React from 'react'

export const NavButton = (props) => {
  const { value_id, icon, label, ...buttonProps } = props
  return (
    <Button value={value_id} variant="ghost" justifyContent="start" {...buttonProps}>
      <HStack spacing="3">
        <Icon as={icon} boxSize="6" color="subtle" />
        <Text>{label}</Text>
      </HStack>
    </Button>
  )
}
